// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mini-spinner-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  margin-bottom: 6px;
  justify-content: center;
  align-items: center;
}

.mini-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #e0e0e0;
  border-top: 2px solid #3366cc;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.mini-spinner-label {
  font-size: 12px;
  color: #555;
  -webkit-user-select: none;
          user-select: none;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.message-icon {
  margin-inline-end: 4px;
  font-size: 16px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/spinner/spinner.scss"],"names":[],"mappings":"AAAA;EACK,aAAA;EACG,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AACR;;AACA;EACI,WAAA;EACM,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,oCAAA;AAEV;;AAAA;EACE,eAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AAGF;;AAAA;EACE;IACE,uBAAA;EAGF;EADA;IACE,yBAAA;EAGF;AACF;AADA;EACE,sBAAA;EACA,eAAA;EACA,sBAAA;AAGF","sourcesContent":[".mini-spinner-wrapper{\r\n     display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        margin-top: 6px;\r\n        margin-bottom: 6px;\r\n        justify-content:center;\r\n        align-items: center;\r\n}\r\n.mini-spinner{\r\n    width: 14px;\r\n          height: 14px;\r\n          border: 2px solid #e0e0e0;\r\n          border-top:2px solid #3366cc;\r\n          border-radius: 50%;\r\n          animation: spin 0.8s linear infinite;\r\n}\r\n.mini-spinner-label {\r\n  font-size: 12px;\r\n  color: #555;\r\n  user-select: none;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.message-icon {\r\n  margin-inline-end: 4px;\r\n  font-size: 16px;\r\n  vertical-align: middle;\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
